import React from 'react'
import PropTypes from 'prop-types'
import Upload from './Upload'
import AlertContainer from 'react-alert'
import { alertOptions } from '../../constants'
import { createFile, getFileByFilename } from '../../api/files'

class UploadContainer extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      uploadState: {
        isUploading: false,
        uploaded: false,
        failed: false
      }
    }
    this.onFileExists = props.onFileExists || this.defaultOnFileExists
  }

  componentDidMount () {}

  onUploadProgress = event => {
    var percentCompleted = Math.round((event.loaded * 100) / event.total)
    console.info('onUploadProgress percentCompleted', percentCompleted)
  }

  reportError = (error) => {
    const errorMessage = error.data ? error.data.message : 'An error occurred while uploading'
    this.msg.show(errorMessage, { type: 'error', time: 6000 })
    if (this.props.onError) this.props.onError(error)
  }

  defaultOnFileExists = (file) => {
    const link = `${window.location.origin}/files/${file.id}/replace`
    alert(`File with file name "${file.name}" already exists. Go to ${link} to replace it.`)
    return false
  }

  upload = async (event) => {
    const files = event.target.files
    const filename = files[0].name
    let proceed = true

    try {
      const file = await getFileByFilename({filename})
      proceed = await this.onFileExists(file)
    } catch (error) {
      if (error.status !== 404) {
        this.reportError(error)
        proceed = false
      }
      // 404 - this is new filename - go ahead with upload
    }

    if (proceed) {
      if (this.props.onStart) this.props.onStart()
      try {
        const file = await createFile(files, this.onUploadProgress)
        this.props.onFinish(file)
      } catch (error) {
        this.reportError(error)
      }
    }

    if (this.input) {
      this.input.value = ''
    }
  }

  getRef = input => {
    this.input = input
    if (this.props.getRef) this.props.getRef(input)
  }

  render () {
    return (
      <div>
        <AlertContainer ref={a => (this.msg = a)} {...alertOptions} />
        <Upload upload={this.upload}
          uploadState={{}}
          {...this.props}
          getRef={this.getRef}
           />
      </div>
    )
  }
}

UploadContainer.propTypes = {
  onError: PropTypes.func,
  onStart: PropTypes.func,
  onFinish: PropTypes.func,
  onFileExists: PropTypes.func,
  getRef: PropTypes.func
}

export default UploadContainer



// WEBPACK FOOTER //
// ./src/components/Upload/UploadContainer.js